import { all, call, put, takeEvery } from "redux-saga/effects";
import * as actions from "../slices/supplierSlice";
import supplierApis from "src/api/supplier";
import { common } from "src/types";
import { constants } from "src/constants/common";

// Create
function* CreateSupplierSaga({
  payload,
}: ReturnType<typeof actions.createSupplierRequest> & { payload: any }) {
  try {
    const response: common.ResponseGenerator = yield call(
      supplierApis.createSupplier,
      payload
    );
    yield put(actions.createSupplierSuccess(response));
  } catch (error) {
    yield put(
      actions.createSupplierError(
        error instanceof Error
          ? error.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
}

// List
function* GetSupplierListSaga({
  payload,
}: ReturnType<typeof actions.getSupplierListRequest>) {
  try {
    const response: common.ResponseGenerator = yield call(
      supplierApis.getSupplierList,
      payload
    );
    yield put(actions.getSupplierListSuccess(response));
  } catch (error) {
    yield put(
      actions.getSupplierListError(
        error instanceof Error
          ? error.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
}

// Edit
function* EditSupplierSaga({
  payload,
}: ReturnType<typeof actions.editSupplierRequest> & { payload: any }) {
  try {
    const response: common.ResponseGenerator = yield call(
      supplierApis.editSupplier,
      payload
    );
    yield put(actions.editSupplierSuccess(response));
  } catch (error) {
    yield put(
      actions.editSupplierError(
        error instanceof Error
          ? error.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
}

export default function* supplierSaga() {
  yield all([
    takeEvery(actions.createSupplierRequest, CreateSupplierSaga),
    takeEvery(actions.getSupplierListRequest, GetSupplierListSaga),
    takeEvery(actions.editSupplierRequest, EditSupplierSaga),
  ]);
}
